var map = {
	"./btn_chip_1.png": "5af0",
	"./btn_chip_2.png": "a100",
	"./btn_chip_3.png": "7b71",
	"./btn_chip_4.png": "c833",
	"./btn_chip_5.png": "e12b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa5";